import { Link } from 'react-router-dom';
import {
  faqs,
  faqUpdatedOn,
  getFaqAnswerParagraphs,
  getFaqParagraphParts,
} from '../../data/faqData';

const faqFont = {
  title: {
    fontSize: 'clamp(20px, 2.4vw, 24px)',
    lineHeight: 1.25,
  },
  question: { fontSize: '18px', lineHeight: 1.5 },
  answer: { fontSize: '16px', lineHeight: 1 },
};

export default function Faq() {
  return (
    <div className="w-full" style={{ fontSize: '17px' }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <div
          style={{
            width: '100%',
            textAlign: 'center',
            marginBottom: '1.25rem',
            paddingLeft: 'clamp(10px, 1.5vw, 22px)',
            paddingRight: 'clamp(10px, 1.5vw, 22px)',
            boxSizing: 'border-box',
          }}
        >
          <h2 style={{ margin: 0, fontWeight: 700, ...faqFont.title }}>
            Frequently Asked Questions
          </h2>
          <p style={{ margin: '0.35rem 0 0', fontSize: '14px', fontWeight: 600, color: '#666' }}>
            Updated {faqUpdatedOn}
          </p>
        </div>
        <div
          style={{
            width: '100%',
            maxWidth: '860px',
            border: '1px solid #dbdbdb',
            borderRadius: '10px',
            padding: 'clamp(1.5rem, 3vw, 2.25rem)',
            backgroundColor: '#fff',
            ...faqFont.answer,
          }}
        >
          {faqs.map((item, i) => {
            const paragraphs = getFaqAnswerParagraphs(item);
            return (
              <div key={i} style={{ marginBottom: 0 }}>
                <p style={{ margin: 0, fontWeight: 600, ...faqFont.question }}>
                  {i + 1}. {item.q}
                </p>
                {paragraphs.map((paragraph, pIndex) => (
                  <p
                    key={pIndex}
                    style={{
                      margin: 0,
                      marginBottom:
                        item.spacedParagraphs && pIndex < paragraphs.length - 1 ? '1em' : 0,
                      color: '#444',
                      lineHeight: item.spacedParagraphs ? 1 : faqFont.answer.lineHeight,
                      fontSize: faqFont.answer.fontSize,
                    }}
                  >
                    {getFaqParagraphParts(paragraph).map((part, partIndex) => {
                      if (typeof part === 'string') return part;
                      if (part.to)
                        return (
                          <Link
                            key={partIndex}
                            to={part.to}
                            style={{
                              color: 'inherit',
                              fontSize: 'inherit',
                              fontWeight: 'inherit',
                              textDecoration: 'underline',
                            }}
                          >
                            {part.text}
                          </Link>
                        );
                      return (
                        <strong
                          key={partIndex}
                          style={{ fontWeight: part.bold === 'heavy' ? 800 : 600 }}
                        >
                          {part.text}
                        </strong>
                      );
                    })}
                  </p>
                ))}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
